/**
 * Builds a unique localStorage key for ProTable columnsState so different tables
 * or dynamic column definitions do not share visibility/order persistence.
 */
export function buildProTableColumnsPersistenceKey({
  columnProps,
  relatedList,
  relatedObject,
  relatedId,
  columns,
}) {
  const name =
    columnProps &&
    typeof columnProps.name === "string" &&
    columnProps.name.trim()
      ? columnProps.name.trim()
      : "table";
  const related =
    relatedList && relatedObject != null && relatedId != null
      ? `${relatedObject}-${relatedId}`
      : "main";
  const keys = (columns || [])
    .map((c) => String(c.key ?? c.dataIndex ?? ""))
    .filter(Boolean)
    .sort()
    .join(",");
  let h = 0;
  for (let i = 0; i < keys.length; i++) {
    h = ((h << 5) - h + keys.charCodeAt(i)) | 0;
  }
  const fingerprint = Math.abs(h).toString(36);
  return `pro-table-cols-v3-${name}-${related}-${fingerprint}`;
}
